import { shape, string } from "prop-types"

export const ClientShape = shape({
    clientId: string.isRequired,
    name: string.isRequired,
    code: string.isRequired
})